<template>
    <div>
        <!-- <MdTitleRegInfo
            v-bind:RegistrationInfo="{}"
            v-bind:titlePrefix="'Log Notes'"
            v-bind:titleRef="'titleElementLogNotes'">
        </MdTitleRegInfo>-->

        <!--<LogNoteMultiple  v-bind="$attrs" :ShowBar="false" :OpenedFromTheNurses="true"></LogNoteMultiple>-->

        <div class="row" v-if="!this.$attrs.editMode">
            <div class="col-12">
                <div class="accordion" role="tablist">
                    <b-card no-body class="noteSearchPanel mb-0">
                        <b-card-header header-tag="header" class="p-0" role="tab">
                            <b-button block class="collapseBTN text-truncate" v-on:click="Accordion1Click"><b-icon
                                    icon="arrow-down-right-circle" aria-hidden="true"></b-icon>
                               Log Notes
                            </b-button>
                        </b-card-header>

                        <b-collapse id="accordion-1" visible accordion="GroupNotes" role="tabpanel"
                            :class="this.ClassAccordion2" class="groupNotesPanel" v-show="ShowFilter && !ShowNote">
                            <b-card-body class="p-1">
                                <b-card-text class="notesPanelsClinical cutescroll">
                                    <b-row>
                                        <b-col lg="3" md="3" sm="12">
                                            <MdSelect
                                            v-bind:Label="$tc('Shared.Program')"
                                            v-bind:Options="ProgramList"
                                            v-bind:Model="ProgramVmodel"
                                            v-bind:FieldDescription="'name'"
                                            v-bind:FieldCode="'code'"
                                            v-bind:Placeholder="selectPlaceholder"
                                            v-bind:Multiple="false"
                                            v-bind:RequireEvent="true"
                                            v-bind:IfUsevalidation="false"
                                            :Input="ChangeDropDownPrograms"/>
                                        </b-col>
                                            <b-col lg="3" md="3" sm="12">
                                            <MdLookupMultiSelect
                                                v-bind:Label="$tc('Shared.Patient',2)"
                                                v-bind:ModelCode="PatientCodeModel"
                                                v-bind:RefCode="'patientcode'"
                                                v-bind:Api="'Patients'"
                                                v-bind:FieldCode="'patientcode'"
                                                v-bind:FieldDescription="'firstname'"
                                                :SearchTitle="$tc('Shared.Patient',2)"
                                                :GetValues="GetPatientValues"
                                                :InvalidFeedback="$t('Msg.InvalidCode')"
                                                :SearchFieldCode="'PatientCode'"
                                                :AuxFields="PatientAuxFields"
                                                :FieldsDate="PatientFieldsDate"
                                                :ServerSidePagination="true"
                                                v-bind:Fields="PatientBaseFields"/>
                                        </b-col>
                                        <b-col lg="3" md="3" sm="12">
                                            <MdSelect
                                                v-bind:Label="$t('Shared.Building')"
                                                v-bind:Options="BuildinsList"
                                                v-bind:FieldDescription="'description'"
                                                v-bind:FieldCode="'code'"
                                                v-bind:Model="buildings"
                                                v-bind:Multiple="false"
                                                :Input="ChangeDropDownBuilding"
                                                />
                                        </b-col>
                                        <b-col lg="3" md="3" sm="12">
                                            <MdSelect
                                                v-bind:Label="$t('Shared.Level')"
                                                v-bind:Options="LevelList"
                                                v-bind:FieldDescription="'description'"
                                                v-bind:FieldCode="'code'"
                                                v-bind:Model="level"
                                                v-bind:Multiple="false"
                                                :Input="ChangeDropDownLevel"/>
                                        </b-col>
                                    </b-row>

                                     <b-row>
                                        <b-col lg="3" md="3" sm="12">
                                            <MdSelect
                                                v-bind:Label="$tc('Shared.Room')"
                                                v-bind:Options="RoomList"
                                                v-bind:FieldDescription="'name'"
                                                v-bind:FieldCode="'code'"
                                                v-bind:UseResetModel="true"
                                                v-bind:Model="room"
                                                v-bind:Multiple="false"
                                                :Input="ChangeDropDownRoom"/>
                                        </b-col>
                                    </b-row>


                                    <div class="row">
                                        <div class="col-12 mt-2">
                                           <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>


                                            <MdTable
                                                v-bind:fields="fields"
                                                v-bind:items="items"
                                                v-bind:totalRows="totalRows"
                                                v-bind:showMessageIsEmpty="showMessageIsEmpty"
                                                v-bind:currentPage="currentPage"
                                                v-bind:perPage="perPage"
                                                v-bind:pageOptions="pageOptions"
                                                v-bind:FieldsDate="fieldsDateArr"
                                                :pageChanged="pageChanged"
                                                :perPageFunction="perPageFunction"
                                                v-bind:multiSelect="true"
                                                v-bind:ShowSelectAll="true"
                                                v-bind:ShowSelectedCount="true"
                                                v-bind:ShowSearchCriteria="true"
                                                v-bind:SelectionKey="'recordId'"
                                                v-bind:SelectAllFunction="getAllForSelectAll"
                                                :onSearchCriteria="onSearchCriteriaChanged"
                                                :customActionButtons="customActionButtons"
                                                @selectionChanged="onSelectionChanged"
                                                :isReadOnly="false"
                                                ref="LogNoteMultipleTable"
                                            >
                                            </MdTable>


                                        </div>
                                        <div class="space-actions">&nbsp;</div>
                                    </div>
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>

                    <b-card no-body class="openNotesPanel mb-0">
                        <b-card-header header-tag="header" class="p-0" role="tab">
                            <b-button block class="collapseBTN" v-on:click="ClickBtnAccordion2"><b-icon
                                    icon="arrow-down-right-circle" aria-hidden="true"></b-icon>
                                {{$t('GroupNotesAccordion.GroupNote')}} - Name  <span
                                    class="highlightInTitle blueTitle">Status</span></b-button>
                        </b-card-header>
                        <b-collapse id="accordion-2" :visible="showMdNote" accordion="ClinicalNotes" role="tabpanel"
                           ref="a2" v-show="ShowNote && !ShowFilter">
                            <b-card-body v-if="showMdNote" class="p-1">
                                <b-card-text class="notesPanels">
                                    <!-- OPEN NOTES CODE -->
                                    <div ref="ContainerNotes">
                                        <LogNoteMultiple
                                            :key="'LogNoteEdit'" v-if="!this.$attrs.editMode && showMdNote"
                                            :AdmissionRecIdMultiple="AdmissionRecIdMultiple"
                                            :PatientCodeMultiple="PatientCodeMultiple"
                                            v-bind="$attrs"
                                            :ShowBar="false"
                                            :OpenedFromTheNurses="true">
                                        </LogNoteMultiple>
                                    </div>
                                    <!-- END OPEN NOTES CODE -->
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </div>
        </div>



        <LogNoteMultiple :key="'LogNoteEdit'" v-if="this.$attrs.editMode"  v-bind="$attrs" :ShowBar="false" :OpenedFromTheNurses="true"></LogNoteMultiple>
    </div>
</template>

<script>
import LogNoteMultiple from '@/components/pages/clinical/lognotes/LogNotes.vue'
import { EventBus } from '@/event-bus.js';
import GlobalService from '@/services/global.service'
import ClinicalService from '@/services/clinical.service'
import AdmissionService from '@/services/admission.service'
import MarsService from '@/services/mars.service'
import Utils from '@/common/utils';
export default {
  name: 'lognotemultiple',
  props:{

  },
  components:{LogNoteMultiple},
  data(){
    return {
        AdmissionRecIdMultiple:null,
        PatientCodeMultiple:null,
        modelSearch:"",
        SelectedRecords: 0,
        showMdNote: false,
        UseSelectTableAll:false,
        ProgramList:[],
        ProgramVmodel:[],
        PatientAuxFields:['lastname'],
        PatientFieldsDate:['dob'],
        BuildinsList:[],
        LevelList:[],
        RoomList:[],
        PatientCodeModel:[],
        showMessageIsEmpty:false,
        pageOptions: [5, 10, 15 ],
        fieldsDateArr:[],
        selectedItems:[],
        level:"",
        buildings:"",
        room:"",
        selectPlaceholder: this.$t('Clinical.SelectOptions'),
        PatientBaseFields:[
            { key: 'firstname', sortable: true, label: this.$t('Shared.FirstName') },
            { key: 'lastname', sortable: true, label: this.$t('Shared.LastName') },
            { key: 'patientcode', sortable: true, label: this.$t('Shared.Code') },
            { key: 'dob', sortable: true, label: this.$t('Shared.Dob') },
            { key: 'cellPhone', sortable: true, label: this.$t('Shared.CellPhone') },
            { key: 'address1', sortable: true, label: this.$t('Shared.Address1') },
            { key: 'city', sortable: true, label: this.$t('Shared.City') },
            { key: 'state', sortable: true, label: this.$t('Shared.State') },
            { key: 'country', sortable: true, label: this.$t('Shared.Country') },
            { key: 'zip', sortable: true, label: this.$t('Shared.Zip') }
        ],
        items:[],
        totalRows:0,
        currentPage:1,
        perPage: 10,
        PageSize:10,
        customActionButtons:[],
        parameter:{
            PatientList:[],
            LevelList:[],
            BuildingList:[],
            RoomList:[],
            NursingUnitsList:[],
            ProgramList:[],
            SearchCriteria:null,
            PageSize:10,
            PageNumber:1
        },
        ShowNote: false,
		ShowFilter: true,
        ClassAccordion2: '',
        dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
         OptionsRightMenu:{
            visible:false,
            btnLogNoteNurseVisible:!this.$attrs.editMode,
            ItemsList:[],
            btnGroupNotesvisible:false,
            btnIncidentWorkflowvisible:false,
            btnDrugOrdersInboxvisible:false,
            btnPatientsPortalDashboardVisible:false,
            btnvisible:false,
            itemdisabled: false,

        },
    }
  },

computed: {
        fields() {
            const isCMHC = this.$store.state.getProviderType?.toString().toUpperCase() === 'CMHC';

            return [
                {
                    key: 'patientName',
                    sortable: true,
                    label: this.$t('Shared.PatientName'),
                    class: 'text-left'
                },
                {
                    key: 'nickname',
                    sortable: true,
                    label: this.$t('Shared.NickName'),
                    class: 'text-left'
                },
                {
                    key: 'patientCode',
                    sortable: true,
                    label: this.$t('Shared.PatientCode'),
                    class: 'text-center'
                },
                { key: 'dob', sortable: true, label: this.$t('Shared.Dob'), class: 'text-center' },
                {
                    key: 'programName',
                    sortable: true,
                    label: this.$tc('Shared.Program'),
                    class: 'text-left'
                },
                {
                    key: 'programCode',
                    sortable: true,
                    label: this.$t('Shared.ProgramCode'),
                    class: 'text-center hidden'
                },
                {
                    key: 'dateFrom',
                    sortable: true,
                    label: this.$t('Shared.datefrom'),
                    class: 'text-right'
                },

                ...(isCMHC
                    ? []
                    : [
                          {
                              key: 'lengthStay',
                              sortable: true,
                              label: this.$t('Clinical.LengthOfStay'),
                              class: 'text-center'
                          }
                      ]),

                {
                    key: 'dateTo',
                    sortable: true,
                    label: this.$t('Shared.dateTo'),
                    class: 'text-right'
                },
                {
                    key: 'transactionType',
                    sortable: true,
                    label: this.$t('Shared.TransactionType'),
                    class: 'text-left'
                },
                {
                    key: 'status',
                    sortable: true,
                    label: this.$t('Shared.Status'),
                    class: 'text-right'
                },
                {
                    key: 'recordId',
                    sortable: true,
                    label: this.$t('Shared.RecordId'),
                    class: 'text-center hidden'
                },
                {
                    key: 'chartNo',
                    sortable: true,
                    label: this.$t('Shared.ChartNumber'),
                    class: 'text-center'
                },
                {
                    key: 'isInpatient',
                    sortable: true,
                    label: this.$t('Shared.Inpatient'),
                    class: 'text-center'
                },

                ...(isCMHC
                    ? []
                    : [
                          {
                              key: 'roomName',
                              sortable: true,
                              label: this.$tc('Shared.Room'),
                              class: 'text-center'
                          }
                      ]),

                ...(isCMHC
                    ? []
                    : [
                          {
                              key: 'buildingName',
                              sortable: true,
                              label: this.$t('Shared.BuildingName'),
                              class: 'text-center'
                          }
                      ])
            ];
        }
    },

  methods:{
    onChangeSelectAll(){

    },
    FindinItems(){

    },
    getAllForSelectAll(){

    },



   /* onSelectionChanged(items) {
        this.selectedItems = items;
        EventBus.$emit('onUpdateLogNotesPatientNodes', this.selectedItems);
    },*/

    onSelectionChanged(items) {
        const currentSelected = items || [];

        EventBus.$emit('onUpdateLogNotesPatientNodes', {
            current: currentSelected,
            previous: this.selectedItems
        });

        this.selectedItems = currentSelected;
    },

    onSearchCriteriaChanged(){

    },
    Accordion1Click(){
        this.ShowFilter = !this.ShowFilter;
		this.ShowNote = !this.ShowNote;
    },

    ClickBtnAccordion2(){
        this.ShowFilter = !this.ShowFilter;
		this.ShowNote = !this.ShowNote;
    },
    async ChangeDropDownLevel(item){
        this.parameter.LevelList = [];
        item ? this.parameter.LevelList.push(item.code) : this.parameter.LevelList = [];
        this.totalRows = 0;
        this.getListing();
    },

    ChangeDropDownRoom(item){
        this.parameter.RoomList = [];
        item ? this.parameter.RoomList.push(item.code) : this.parameter.RoomList = [];
        this.totalRows = 0;
        this.getListing();
    },

     async ChangeDropDownBuilding(item){
        this.parameter.BuildingList = [];
        item ? this.parameter.BuildingList.push(item.code) : this.parameter.BuildingList = [];
        await this.getRomms({BuildingCodeList:this.parameter.BuildingList});
        this.parameter.RoomList = [];
        this.room ? this.parameter.RoomList.push(this.room) : this.parameter.RoomList;
        this.totalRows = 0;
        this.getListing();
    },

    ChangeDropDownPrograms(item){
        this.parameter.ProgramList = [];
        item ? this.parameter.ProgramList.push(item.code) : this.parameter.ProgramList = [];
        this.totalRows = 0;
        this.getListing();
    },

     GetPatientValues(value){
        this.PatientCodeModel = value;
        this.parameter.PatientList = value ? value : [];
        this.totalRows = 0;
        this.getListing();
    },

    async getBuildings(){
            await AdmissionService.getBuildings({Code: this.$store.state.restrictions.buildingLocation})
                    .then((response) => {
                        if(response.status == '200'){
                            this.BuildinsList = response.data;

                            if (!this.buildingsEnabled) {
                                this.buildings = this.$store.state.restrictions.buildingLocation;
                                this.parameter.BuildingList.push(this.buildings);
                            }
                        }
                    })
                    .catch((error) => {
                    this.showResponseErrorMessage(error);
                    });
        },

        async getPrograms(){
            const parameter = {
                    programsRestriction:  this.$store.state.restrictions.programs
            }
        await ClinicalService.getPrograms(parameter)
                    .then((response) => {
                        if(response.status == '200' && response.data && response.data.length > 0){
                        this.ProgramList = response.data;
                        }
                    })
                    .catch((error) => {
                        this.showResponseErrorMessage(error);
                    });
        },

    async getLevel(){
        let param = {
            CodeType:"RoomLevel",
            OrderBy:"SeqNo"
        };
            await GlobalService.getGlobalCustom(param)
                    .then((response) => {
                        if(response.status == '200' && response.data.length > 0){
                            this.LevelList = response.data;
                        }
                    })
                    .catch((error) => {
                        this.showResponseErrorMessage(error);
                    });
        },

    async getRomms(build){
            await MarsService.getMarsRooms(build)
                    .then((response) => {
                        if(response.status == '200' && response.data.length > 0){
                            this.RoomList = response.data;
                            if(this.RoomList.length === 1){
                                this.room = this.RoomList[0].code;
                            }else{
                                EventBus.$emit('OnResetModelSelect');
                                this.room = "";
                            }

                        }
                    })
                    .catch((error) => {
                        this.showResponseErrorMessage(error);
                    });

    },

    perPageFunction(perPage) {
        this.perPage = perPage;
        this.currentPage = 1;
        this.getListing();
    },

     pageChanged(page) {
            this.currentPage = page;
            this.getListing();
        },

    getListing(){
            this.parameter.PageSize = this.perPage;
            //this.parameter.Status = this.StatusVModel.value;
            //this.parameter.IsInPatient = this.TypeVModel.value;

            ClinicalService.getAll(this.parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.items = response.data;
                        if (response.data.length > 0) {
                            this.items.forEach(function(element) {
                                element.isNew = true;
                                let { dob, dateFrom, dateTo } = element;
                                if (dob) element.dob = Utils.formatterDateToString(dob);
                                if (dateFrom)
                                    element.dateFrom = Utils.formatterDateToString(dateFrom);
                                if (dateTo) element.dateTo = Utils.formatterDateToString(dateTo);
                            });
                        }
                        let headerString = response.headers['x-pagination'];
                        this.Header = JSON.parse(headerString);
                        this.totalRows = this.Header.TotalCount;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
    }
  },

  created(){
    if(!this.$attrs.editMode){
       Promise.allSettled([
        this.getPrograms(),
        this.getBuildings(),
        this.getLevel(),
        this.getRomms({BuildingCodeList:[]}),
        ]).then((result) => result.length === 4 ? this.getListing() :null);
    }

    EventBus.$on("onPatientClickLogNoteEnableForm", function () {
        this.ShowNote = true;
		this.ShowFilter = false;
		this.showMdNote = true;
    }.bind(this));

    EventBus.$on("onClickPatientLogNoteMultiple", function (data) {
        this.AdmissionRecIdMultiple = data.admissionrecid;
        this.PatientCodeMultiple = data.patientcode;
       // this.ResetForm();
    }.bind(this));

  },

  mounted(){
		this.OptionsRightMenu.ItemsList = [];
        !this.$attrs.editMode ?  this.$store.commit('setlayoutStatus', 'L0R1') : this.$store.commit('setlayoutStatus', 'L0R0');
		this.$emit('getVisibleMenuLogNotes', this.OptionsRightMenu);
  },

  beforeDestroy () {
    EventBus.$off('onClickPatientLogNoteMultiple');
    EventBus.$off('onPatientClickLogNoteEnableForm');
 },

};
</script>


